import { app } from '../constants';

export default {
  updateLocators: payload => ({ type: app.UPDATE_LOCATORS, data: payload }),
  updateMachineData: payload => ({ type: app.UPDATE_MACHINE_DATA, data: payload }),
  updateLocatorFilter: payload => ({ type: app.UPDATE_LOCATOR_FILTER, data: payload }),
  updateHighlightedMachine: payload => ({ type: app.UPDATE_HIGHLIGHTED_MACHINE, data: payload }),
  updateOpenMachine: payload => ({ type: app.UPDATE_OPEN_MACHINE, data: payload }),
  updateOpenMachineSelectedJob: payload => ({ type: app.UPDATE_OPEN_MACHINE_SELECTED_JOB, data: payload }),
  updateInsertJobType: payload => ({ type: app.UPDATE_INSERT_JOB_TYPE, data: payload }),
  updateLocationData: payload => ({ type: app.UPDATE_LOCATION_DATA, data: payload }),
  updateNotesModalCb: payload => ({ type: app.UPDATE_NOTES_MODAL_CB, data: payload }),
  updateNotesInitValue: payload => ({ type: app.UPDATE_NOTES_INIT_VALUE, data: payload }),
  updateTimelineViewType: payload => ({ type: app.UPDATE_TIMELINE_VIEW_TYPE, data: payload }),
  updateTimelineTextFilter: payload => ({ type: app.UPDATE_TIMELINE_TEXT_FILTER, data: payload }),
  updateWeekFilter: payload => ({ type: app.UPDATE_WEEK_FILTER, data: payload }),
};